<div style="margin-top: 20px;">
    <div fxLayout="row wrap">
        <div fxFlex="30" fxFlex.gt-sm="30" class="p-1">&nbsp;</div>
        <div fxFlex="40" fxFlex.gt-sm="40" class="p-1 mt-2">
            <img alt="akshaya-logo" src="../../../assets/images/akshaya-logo.png" class="akshaya-logo">
        </div>
        <div fxFlex="30" fxFlex.gt-sm="30" class="p-1">&nbsp;</div>
    </div>
</div>